module.exports = {
    "collapse": `\u{6536}\u{5408}`,
    "expand": `\u{5C55}\u{958B}`
};


//# sourceMappingURL=zh-TW.main.js.map
